/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Employer/view.blocks to change it.
import * as fromData from 'Simple/Data'
import Options from './Options/index'
import React from 'react'
import TysiaSelectOne from 'DesignSystem/TysiaSelectOne/index'
import TysiaSelectOneArrow from 'DesignSystem/TysiaSelectOne/TysiaSelectOneArrow/index'
import TysiaSelectOneContent from 'DesignSystem/TysiaSelectOne/TysiaSelectOneContent/index'
import TysiaSelectOneInput from 'DesignSystem/TysiaSelectOne/TysiaSelectOneInput/index'
import TysiaSelectOneLabel from 'DesignSystem/TysiaSelectOne/TysiaSelectOneLabel/index'
import TysiaSelectOneOptions from 'DesignSystem/TysiaSelectOne/TysiaSelectOneOptions/index'
import TysiaSelectOnePopover from 'DesignSystem/TysiaSelectOne/TysiaSelectOnePopover/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Employer({
  children,
  viewPath = "/DesignSystem/DataVaxiomPatientInsuranceAssignForm/Content/Employer",
  onChange
  
}) {
let assignDetailsOnlyCoverageValueData = fromData.useDataValue({ viewPath,
context: 'assign_details',
path: 'onlyCoverage',
})
let optionsValueData = fromData.useDataValue({ viewPath,
context: 'options',
})
let selectedSearchValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'search',
})
let selectedSearchChangeData = fromData.useDataChange({ viewPath,
context: 'selected',
path: 'search',
})
let txCategoryInsuredInsuredInsuranceSubscriptionEmployerIdValueData = fromData.useDataValue({ viewPath,
context: 'tx_category_insured',
path: 'insured.insurance_subscription.employer_id',
})
let txCategoryInsuredInsuredInsuranceSubscriptionEmployerIdChangeData = fromData.useDataChange({ viewPath,
context: 'tx_category_insured',
path: 'insured.insurance_subscription.employer_id',
})
  return (<React.Fragment
>
<TysiaSelectOne
  viewPath={`${viewPath}/TysiaSelectOne`}
 marginTop={0}
 data="assign_details.onlyCoverage"
 disabled={assignDetailsOnlyCoverageValueData}
 data="options"
 from={optionsValueData}
 data="selected.search"
 valueFilter={selectedSearchValueData}
 onChangeFilter={selectedSearchChangeData}
 data="tx_category_insured.insured.insurance_subscription.employer_id"
 value={txCategoryInsuredInsuredInsuranceSubscriptionEmployerIdValueData}
 onChange={txCategoryInsuredInsuredInsuranceSubscriptionEmployerIdChangeData}
>
{childProps => (
<React.Fragment>
<div
  data-testid="Employer.Horizontal"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaSelectOneLabel
  viewPath={`${viewPath}/TysiaSelectOneLabel`}
 text="Employer"
/>
<Options
  viewPath={`${viewPath}/Options`}
/>
</div>
<TysiaSelectOneContent
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneContent`}
>
{childProps => (
<React.Fragment>
<TysiaSelectOneInput
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneInput`}
/>
<TysiaSelectOneArrow
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneArrow`}
/>
<TysiaSelectOnePopover
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOnePopover`}
>
{childProps => (
<TysiaSelectOneOptions
{...childProps}
  viewPath={`${viewPath}/TysiaSelectOneOptions`}
/>
)}
</TysiaSelectOnePopover>
</React.Fragment>
)}
</TysiaSelectOneContent>
</React.Fragment>
)}
</TysiaSelectOne>
{children}
</React.Fragment>)
}